import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=6d9b1a3e&scoped=true&"
import script from "./addOwner.vue?vue&type=script&lang=js&"
export * from "./addOwner.vue?vue&type=script&lang=js&"
import style0 from "./addOwner.vue?vue&type=style&index=0&id=6d9b1a3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b1a3e",
  null
  
)

export default component.exports